function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgHrk = function SvgHrk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M512,256c0-31.314-5.633-61.311-15.923-89.043L256,155.826l-240.077,11.13 C5.633,194.689,0,224.686,0,256s5.633,61.311,15.923,89.043L256,356.174l240.077-11.13C506.367,317.311,512,287.314,512,256z"
  }), React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M256,512c110.071,0,203.906-69.472,240.077-166.957H15.923C52.094,442.528,145.929,512,256,512z"
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M15.923,166.957h480.155C459.906,69.472,366.071,0,256,0S52.094,69.472,15.923,166.957z"
  }), React.createElement("g", null, React.createElement("polygon", {
    style: {
      fill: "#338AF3"
    },
    points: "322.783,178.088 278.261,178.088 285.682,122.435 315.362,100.174 345.043,122.435  345.043,166.957  "
  }), React.createElement("polygon", {
    style: {
      fill: "#338AF3"
    },
    points: "189.217,178.088 233.739,178.088 226.318,122.435 196.637,100.174 166.957,122.435  166.957,166.957  "
  })), React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "285.682,178.088 226.318,178.088 226.318,122.435 256,100.174 285.682,122.435 "
  }), React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M166.957,166.958v122.434c0,29.153,14.082,55.079,35.802,71.332l15.583-3.899l19.664,19.782 c5.815,1.198,11.832,1.829,17.995,1.829c6.13,0,12.117-0.623,17.901-1.809l22.447-18.69l12.892,2.751 c21.711-16.252,35.803-42.151,35.803-71.296V166.958H166.957z"
  }), React.createElement("g", null, React.createElement("rect", {
    x: 166.957,
    y: 166.957,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), React.createElement("rect", {
    x: 238.191,
    y: 166.957,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), React.createElement("rect", {
    x: 309.426,
    y: 166.957,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), React.createElement("rect", {
    x: 202.574,
    y: 202.574,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), React.createElement("rect", {
    x: 273.809,
    y: 202.574,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), React.createElement("rect", {
    x: 166.957,
    y: 238.18,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), React.createElement("rect", {
    x: 202.574,
    y: 273.798,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), React.createElement("rect", {
    x: 238.191,
    y: 238.18,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), React.createElement("rect", {
    x: 309.426,
    y: 238.18,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), React.createElement("rect", {
    x: 273.809,
    y: 273.798,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), React.createElement("rect", {
    x: 238.191,
    y: 309.415,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M202.574,309.418h-33.319c3.056,13.24,9.064,25.355,17.302,35.617h16.017V309.418z"
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M309.426,345.036h16.016c8.24-10.262,14.246-22.378,17.302-35.617h-33.318V345.036z"
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M202.574,345.036v15.541c10.359,7.795,22.465,13.384,35.617,16.066v-31.607H202.574z"
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M273.809,345.036v31.607c13.153-2.68,25.258-8.271,35.617-16.066v-15.541H273.809z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHrk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HRK.f4018d22.svg";
export { ForwardRef as ReactComponent };